import {extend} from 'flarum/extend';
import Button from 'flarum/components/Button';
import FieldSet from 'flarum/components/FieldSet';
import SettingsPage from 'flarum/components/SettingsPage';
import DeleteUserModal from "../components/DeleteUserModal";

import Stream from 'flarum/utils/Stream';
import withAttr from "flarum/utils/withAttr";

export default function () {

  const FORM_GROUP = "Form-group";
  const ALERT_SECONDS_EXCEED = 10;

  extend(SettingsPage.prototype, 'oninit', function () {
    this.loading = false;
    this.username = Stream(this.user.username());
    this.fullname = Stream(this.user.fullname() ?? this.user.displayName());
    this.email = Stream(this.user.email());
  });

  extend(SettingsPage.prototype, 'settingsItems', function (items) {
    this.addProfileSettings(items);
    this.addDeleteProfile(items);
  });

  SettingsPage.prototype.addProfileSettings = function (items) {
    items.add(
      'profile',
      FieldSet.component({
        label: app.translator.trans('core.forum.user.settings.profile.header'),
        className: 'Settings-profile',
      },
        [
          m('div', {className: FORM_GROUP}, [
            m('p', {}, app.translator.trans('core.forum.user.settings.profile.subtitle')),
            this.createFormItem('username'),
            this.createFormItem('fullname'),
            this.createFormItem('email'),
            Button.component({
              className: 'Button Button--primary',
              onclick: this.onsubmit.bind(this),
              loading: this.loading,
            }, app.translator.trans('core.forum.edit_user.submit_button'))
          ])
        ]
      ),
      100
    );
  }

  SettingsPage.prototype.createFormItem = function (variable) {
    return (
      m('div', {className: FORM_GROUP}, [
        m('label', {}, app.translator.trans(`core.forum.user.settings.profile.${variable}`)),
        m('input', {
          className: "FormControl",
          value: this[variable](),
          oninput: withAttr('value', this[variable])
        }, this[variable]())
      ])
    );
  }

  SettingsPage.prototype.addDeleteProfile = function (items) {
    items.add(
      'delete-profile',
      FieldSet.component({
        label: app.translator.trans('core.forum.user.settings.delete.header'),
        className: 'Settings-delete-profile',
      },
        (
          m('div', {className: FORM_GROUP}, [
            m('p', {}, app.translator.trans('core.forum.user.settings.delete.text')),
            Button.component({
              className: 'Button button-delete',
              onclick: () => app.modal.show(DeleteUserModal),
            }, app.translator.trans('core.forum.user.settings.delete.button'))
          ])
        )
      ),
      -100
    );
  }

  SettingsPage.prototype.data = function () {
    return {
      username: this.username(),
      fullname: this.fullname(),
      email: this.email()
    };
  }

  SettingsPage.prototype.onsubmit = function (e) {
    e.preventDefault();

    this.loading = true;
    app.request({
      url: `${app.forum.attribute('apiUrl')}/update_user`,
      method: 'POST',
      body: this.data()
    }).then(() => {
      app.alerts.show(
        { type: 'success' },
        app.translator.trans('core.forum.user.settings.basics.saved_message')
      );
      this.user.savePreferences(this.data());
      this.clearAlerts();
    }).catch(() => {
      this.clearAlerts();
    });
  }

  SettingsPage.prototype.clearAlerts = function () {
    setTimeout(() => {
      app.alerts.clear();
    }, ALERT_SECONDS_EXCEED * 1000);
    this.loading = false;
    m.redraw();
  }
}
